import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
import { projectsEndpointIds } from 'root/src/shared/projects/projects.constants';
export const reviewProjectEmailSenderEndpoint = {
    [projectsEndpointIds.REVIEW_DELIVERY_EMAIL_SENDER]: {
        endpointType: otherEndpointType,
    },
};
